import {
  Vacancies,
  VacanciesType,
  ParseVacanciesType,
  MapedVacanciesType,
} from './types';

const parse = (data: Vacancies): Readonly<ParseVacanciesType> =>
  Object.freeze({
    id: data!.id || '',
    name: data!.vacancy_name || '',
    vacancy: data!.vacancy_name || '',
    salary: parseSalary(data!.salary),
    organization: data!.partner_name || '',
    organizationAddress: data!.organization_address || '',
  });

const parseSalary = (val: string) => (val ? `${val.replace(/\B(?=(\d{3})+(?!\d))/g, " ")} руб.` : 'Не указана');

const parseVacancies = (data: VacanciesType): MapedVacanciesType =>
  data.map((item) => parse(item));

export default parseVacancies;



// WEBPACK FOOTER //
// ./src/services/api/vacancies/utils/parseVacancies.ts